import {
  SideNavigationV2Props,
  PageV2Component,
} from "skedyul-ui/src/components/ui/SideNavigationV2";
import { SideNavigationComponentProps } from "@schemas/sideNavigation.schema";
import { store } from "@store/index";
import { close as closeSideNavigation } from "@store/features/layout/sideNavigationSlice";
import type { ButtonProps } from "skedyul-ui/ui";

export type GeneratedReportParams = {
  reportHandle: string;
  reportName: string;
  html: string;
  reportUrl: string;
};

export const generatedReportSchema = (
  args: SideNavigationComponentProps<PageV2Component, { subdomain: string }> & {
    props: GeneratedReportParams;
  },
): SideNavigationV2Props<PageV2Component> => {
  const { sideNavigation } = args.state;
  const params = sideNavigation[args.position]?.params as
    | GeneratedReportParams
    | undefined;

  const reportHandle = args.props.reportHandle || params?.reportHandle || "";
  const reportName = args.props.reportName || params?.reportName || "Report";
  const html = args.props.html || params?.html || "";
  const reportUrl = args.props.reportUrl || params?.reportUrl || "";

  const isOpen = sideNavigation[args.position]?.isOpen ?? true;

  const handleCopyLink = async () => {
    if (reportUrl) {
      await navigator.clipboard.writeText(reportUrl);
    }
  };

  const handleViewFullReport = () => {
    if (reportUrl) {
      window.location.href = reportUrl;
    }
  };

  const handleClose = () => {
    store.dispatch(closeSideNavigation({ position: args.position }));
  };

  const components: any[] = [];

  components.push({
    type: "Card" as const,
    title: "Actions",
    props: {
      className: "mb-4",
      actions: [
        {
          label: "View Full Report",
          leftIcon: "FileText",
          variant: "default",
          size: "sm",
          handleClick: handleViewFullReport,
        } as ButtonProps,
        {
          label: "Copy Link",
          leftIcon: "Link",
          variant: "outline",
          size: "sm",
          handleClick: handleCopyLink,
        } as ButtonProps,
        {
          label: "Close",
          leftIcon: "X",
          variant: "ghost",
          size: "sm",
          handleClick: handleClose,
        } as ButtonProps,
      ],
    },
  });

  components.push({
    type: "ReportViewer" as const,
    title: "Report Content",
    props: {
      html,
    },
  });

  return {
    side: args.position,
    isOpen,
    width: args.width || "600px",
    component: {
      component: "PageV2",
      props: {
        title: reportName,
        content: {
          structure: "sidebar",
          components,
        },
      },
    },
  };
};
